import { cn } from "@newxsystems/shared";
import { VelvetCardLink } from "../../../../modules/content/components/VelvetCardLink/VelvetCardLink";
import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetRichText } from "../../../../modules/content/components/VelvetRichText/VelvetRichText";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { ITextContentGridBlockProps } from "./TextContentGridBlock.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;
const spans = {
  1: "lg:col-span-1",
  2: "lg:col-span-2",
  3: "lg:col-span-3",
  4: "lg:col-span-4",
} as const;

export const TextContentGridBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITextContentGridBlockProps) => {
  if (!items?.length) return null;

  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-16 md:gap-24">
        <VelvetCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div
          className={cn(
            "grid grid-cols-1 border-t border-parchment/50 sm:grid-cols-2",
            columns[columnCount || 3],
          )}
        >
          {items.map((item, index) => (
            <VelvetCardLink
              className={cn(
                "flex min-h-72 flex-col border-b border-parchment/20 bg-transparent py-8 transition-[padding,color] hover:pl-4 hover:text-thread sm:px-6 sm:hover:pl-8 md:min-h-80 md:py-10",
                spans[item.columnSpan || 1],
              )}
              key={index}
              link={item.cardLink}
            >
              <span aria-hidden="true" className="size-3 rotate-45 bg-thread" />
              <h3 className="mt-auto pt-16 font-velvet-display text-5xl font-black uppercase leading-[0.84] tracking-[-0.04em] text-current">
                {item.heading}
              </h3>
              {item.description ? (
                <VelvetRichText
                  className="mt-5 max-w-[34ch] text-base text-smoke md:text-lg"
                  content={item.description}
                />
              ) : null}
            </VelvetCardLink>
          ))}
        </div>
      </div>
    </VelvetSection>
  );
};

TextContentGridBlock.displayName = "Block::TextContentGridBlock";
